import { Button, DatePicker, Spin } from 'antd';
import { baseUrl, formatNumber } from '~/utils/helper';
import { useEffect, useState } from 'react';

import { Analytics } from '~/data/dummy';
import { NS } from '~/utils/ns';
import { RangeDatePicker } from '~/components/common';
import { RangePresets } from '~/components/common/RangeDatePicker';
import axios from 'axios';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { useStateContext } from '~/contexts/ContextProvider';
import { useTranslation } from 'react-i18next';

const { RangePicker } = DatePicker;

const Dashboard = ({ title }) => {
  const { t } = useTranslation([NS['dashboard']]);
  const { formatMoney, ref } = useStateContext();
  const [time, setTime] = useState([dayjs().add(-7, 'd'), dayjs()]);
  const [data, setData] = useState();
  const [isCopy, setIsCopy] = useState(false);
  const [loading, setLoading] = useState(true);

  document.title = title;

  const getData = () => {
    axios
      .get(
        `${baseUrl}/api/daily/list/analytics?startDate=${
          time?.[0] ? time?.[0]?.toISOString() : ''
        }&endDate=${time?.[1] ? time?.[1]?.toISOString() : ''}`,
        {
          headers: {
            'x-access-token': sessionStorage.getItem('auth'),
            'Access-Control-Allow-Origin': '*',
          },
        },
      )
      .then((res) => {
        let { status, data } = res.data;
        if (status) {
          setData(data);
          setLoading(false);
        } else {
          toast.error(t('common:error'), { them: 'light' });
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('common:error'), { them: 'light' });
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const hanldeCopy = () => {
    navigator.clipboard.writeText(
      `https://${window.location.hostname.slice(7)}/register?ref=${ref}`,
    );
    setIsCopy(true);
    setTimeout(() => {
      setIsCopy(false);
    }, 1500);
  };

  const listAnalytic = Analytics();
  const rangePresets = RangePresets();

  // Define card colors and icons
  const cardStyles = [
    { class: 'metric-card-purple', icon: '🆕' },
    { class: 'metric-card-blue', icon: '👥' },
    { class: 'metric-card-green', icon: '💳' },
    { class: 'metric-card-orange', icon: '💸' },
    { class: 'metric-card-red', icon: '🔄' },
    { class: 'metric-card-indigo', icon: '🎁' },
    { class: 'metric-card-pink', icon: '🎮' },
    { class: 'metric-card-teal', icon: '🏆' },
    { class: 'metric-card-teal', icon: '📉' },
  ];

  return (
    <div
      className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100"
      style={{
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}>
      {loading ? (
        <div className="flex flex-col items-center justify-center gap-6" style={{ height: '60vh' }}>
          <Spin size="large" />
          <div
            style={{
              color: '#64748b',
              fontSize: '1.125rem',
              fontWeight: 500,
            }}>
            {t('dang_tai_du_lieu')}
          </div>
        </div>
      ) : (
        <div className="relative p-2 space-y-8 md:p-6">
          {/* Header & Search Section */}
          <div
            className="p-2 mb-6 md:p-6 rounded-2xl"
            style={{
              background: 'rgba(255, 255, 255, 0.8)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            }}>
            <div className="flex flex-wrap items-end justify-between gap-6">
              <div className="flex-shrink-0">
                <h1 className="text-3xl font-bold text-transparent bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text">
                  {t('trang_thong_ke')}
                </h1>
              </div>

              <div className="flex flex-wrap items-end gap-4">
                <div className="min-w-[300px]">
                  {/* <label className="block mb-2 text-sm font-medium text-gray-700">
                    Chọn khoảng thời gian
                  </label> */}
                  <RangePicker
                    placeholder={[t('ngaybatdau'), t('ngayketthuc')]}
                    presets={rangePresets}
                    showTime={{
                      defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')],
                    }}
                    value={time}
                    className="w-full h-12"
                    style={{
                      borderRadius: '12px',
                      border: '2px solid rgba(102, 126, 234, 0.2)',
                      background: 'rgba(255, 255, 255, 0.9)',
                    }}
                    onChange={(value) => setTime(value)}
                    format="YYYY-MM-DD HH:mm:ss"
                  />
                </div>
                <Button
                  type="primary"
                  onClick={getData}
                  loading={loading}
                  className="w-full h-12 px-8 font-semibold md:w-auto"
                  style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    border: 'none',
                    borderRadius: '12px',
                    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
                  }}>
                  {t('common:search')}
                </Button>
              </div>
            </div>
          </div>

          {/* Metrics Grid */}
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 lg:gap-8 md:gap-3">
            {listAnalytic.map((item, index) => {
              const cardStyle = cardStyles[index % cardStyles.length];

              const getCardBackground = (styleClass) => {
                const gradients = {
                  'metric-card-purple': 'linear-gradient(135deg, #5a67d8 0%, #553c9a 100%)',
                  'metric-card-blue': 'linear-gradient(135deg, #3182ce 0%, #00a8cc 100%)',
                  'metric-card-green': 'linear-gradient(135deg, #38a169 0%, #2d7d32 100%)',
                  'metric-card-orange': 'linear-gradient(135deg, #e53e3e 0%, #d69e2e 100%)',
                  'metric-card-red': 'linear-gradient(135deg, #e53e3e 0%, #c53030 100%)',
                  'metric-card-indigo': 'linear-gradient(135deg, #4c51bf 0%, #805ad5 100%)',
                  'metric-card-pink': 'linear-gradient(135deg, #d53f8c 0%, #b83280 100%)',
                  'metric-card-teal': 'linear-gradient(135deg, #319795 0%, #2c7a7b 100%)',
                };
                return gradients[styleClass] || gradients['metric-card-purple'];
              };

              return (
                <div
                  key={index}
                  className="p-6 text-center transition-all duration-300 rounded-2xl hover:transform hover:-translate-y-3 hover:scale-105"
                  style={{
                    background: getCardBackground(cardStyle.class),
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
                    overflow: 'hidden',
                    position: 'relative',
                  }}>
                  <div
                    className="mb-4 text-4xl transition-all duration-300"
                    style={{ opacity: 0.9 }}>
                    {cardStyle.icon}
                  </div>
                  <div
                    className="mb-2"
                    style={{
                      color: 'white',
                      fontWeight: 800,
                      fontSize: '2rem',
                      lineHeight: 1.2,
                      textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    }}>
                    {item.type === 'currency'
                      ? formatMoney(data?.[item.data])
                      : formatNumber(data?.[item.data])}
                  </div>
                  <div
                    style={{
                      color: 'rgba(255, 255, 255, 0.9)',
                      fontWeight: 500,
                      fontSize: '0.875rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                      textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                    }}>
                    {item.name}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
